import uniqBy from 'lodash/uniqBy';
import {
  ADD_DASHBOARDS,
  REMOVE_DIRECT_ACCESS_DASHBOARDS,
  REMOVE_PUBLIC_DASHBOARD,
} from '@/store/modules/dashboard/mutation_types';
import { MUTATE, MUTATE_MULTIPLE } from '@/store/modules/mutation_types';
import { mutate, mutateMultiple } from '@/store/modules/mutations';

export default {
  [MUTATE]: mutate,
  [MUTATE_MULTIPLE]: mutateMultiple,
  [ADD_DASHBOARDS](state, dashboards) {
    const dashMapped = dashboards.map(dash => {
      return {
        id: dash.id,
        data: dash.data(),
      };
    });

    state.dashboards = uniqBy([...dashMapped, ...state.dashboards], (dash) => {
      return dash.id;
    });
  },
  [REMOVE_PUBLIC_DASHBOARD](state) {
    state.dashboards = state.dashboards.filter(dash => !dash.data.isPublished);
  },
  [REMOVE_DIRECT_ACCESS_DASHBOARDS](state) {
    state.dashboards = state.dashboards.filter(dash => dash.data.isPublished);
  },
};
